import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { customerCommunicationStore } from '../../../stores/customerCommunicationStore';
import {
  CUSTOMER_COMMUNICATION_COLUMN,
  CustomerCommunicationColumn,
} from '../NgzCustomerCommunicationList.settings';

type TitleRowProps = {
  visibleColumns: CustomerCommunicationColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { filterMethod } = customerCommunicationStore;
  const { handleSort, getIsSortedBy } = filterMethod;

  const renderColumnsInfo: Record<CustomerCommunicationColumn, ReactElement> = {
    [CUSTOMER_COMMUNICATION_COLUMN.NAME]: (
      <GridTableCell>
        <SortButtons
          fieldName="FULL_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Customer
        </SortButtons>
      </GridTableCell>
    ),
    [CUSTOMER_COMMUNICATION_COLUMN.LOCATION]: (
      <GridTableCell>
        <SortButtons fieldName="LOCATION" onSort={handleSort} getIsActive={getIsSortedBy}>
          Location
        </SortButtons>
      </GridTableCell>
    ),
    [CUSTOMER_COMMUNICATION_COLUMN.GROUP]: <GridTableCell>Group</GridTableCell>,
    [CUSTOMER_COMMUNICATION_COLUMN.COACH]: <GridTableCell>Coach</GridTableCell>,
    [CUSTOMER_COMMUNICATION_COLUMN.START_DATE]: (
      <GridTableCell>
        <SortButtons
          fieldName="START_DATE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Start Date
        </SortButtons>
      </GridTableCell>
    ),
    [CUSTOMER_COMMUNICATION_COLUMN.STATUS]: <GridTableCell>Status</GridTableCell>,
    [CUSTOMER_COMMUNICATION_COLUMN.CUSTOM_FILTER]: <div />,
    [CUSTOMER_COMMUNICATION_COLUMN.ACTIONS]: <div />,
  };

  return (
    <GridTableRow variant="header">
      {visibleColumns.map((col) => (
        <React.Fragment key={col}>{renderColumnsInfo[col]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
